import { RestApi } from "infrontjs";
export class Api
{
    constructor( app )
    {
        this.app = app;

        const region = this.app.storage.loadRegion();
        const apiUrl = region
            ? this.app.config.get( `api.${region}` )
            : this.app.config.get( 'api.eu' );

        this._api = new RestApi(
            apiUrl,
            { "Content-Type": "application/json" }
        );
        this._api.headers.set( 'x-version', this.app.config.get( 'version' ) );
    }

    setRegion( region )
    {
        const url = this.app.config.get( `api.${region}` );
        if ( url )
        {
            this._api.url = url;
        }
    }

    getUrl()
    {
        return this._api.url;
    }

    setSessionToken( sessionToken )
    {
        this._api.headers.set( 'x-sessiontoken', sessionToken );
    }

    deleteSessionToken()
    {
        this._api.headers.delete( 'x-sessiontoken' );
    }

    async get( endpoint )
    {
        return this._processResult( await this._api.get( endpoint ) );
    }

    async post( endpoint, params = {} )
    {
        return this._processResult( await this._api.post( endpoint, params ) );
    }

    async delete( endpoint )
    {
        return this._processResult( await this._api.delete( endpoint ) );
    }

    async put( endpoint, params = {} )
    {
        return this._processResult( await this._api.put( endpoint, params ) );
    }

    async patch( endpoint, params = {} )
    {
        return this._processResult( await this._api.patch( endpoint, params ) );
    }

    _processResult( result )
    {
        if ( result && result.hasOwnProperty( 'status' ) )
        {
            console.log( result );
            // switch ( +result.status )
            // {
            //     case 403:
            //         if ( result.json && result.json?.message && result.json?.message?.error === 'unaccepted_system_messages' )
            //         {
            //             if ( this.app.router.currentRoute !== '/system-message' )
            //             {
            //                 this._api.abortAll();
            //                 this.app.router.redirect( '/system-message' );
            //             }
            //         }
            //         break;
            //     case 440:
            //         this.app.dispatchCustomEvent( 'session-expired' );
            //         throw new Error( 'Session expired.' );
            //         break;
            //
            //     case 499:
            //         this.app.dispatchCustomEvent( 'client-update-required' );
            //         throw new Error( 'Client version outdated.' );
            //         break;
            // }
        }
        return result;
    }
}
